import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installErrorReporter } from "@/lib/errorReporter";

installErrorReporter();

// iter49 P2: @tanstack/react-query was installed in package.json but never
// used (no useQuery / useMutation call sites anywhere). Removed the
// QueryClientProvider here AND the dependency from package.json — saves
// ~40KB on the cold-traffic bundle that 100% of landing-page visitors download.

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
